"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeUpdateAction = exports.VaultDepositorAction = exports.FeeUpdateStatus = exports.FuelDistributionMode = exports.VaultClass = exports.WithdrawUnit = exports.VAULT_PROGRAM_ID = void 0;
exports.isNormalVaultClass = isNormalVaultClass;
exports.isTrustedVaultClass = isTrustedVaultClass;
exports.hasPendingFeeUpdate = hasPendingFeeUpdate;
const web3_js_1 = require("@solana/web3.js");
exports.VAULT_PROGRAM_ID = new web3_js_1.PublicKey('vAuLTsyrvSfZRuRB3XgvkPwNGgYSs9YRYymVebLKoxR');
class WithdrawUnit {
}
exports.WithdrawUnit = WithdrawUnit;
WithdrawUnit.SHARES = { shares: {} };
WithdrawUnit.TOKEN = { token: {} };
WithdrawUnit.SHARES_PERCENT = { sharesPercent: {} };
var VaultClass;
(function (VaultClass) {
    VaultClass[VaultClass["NORMAL"] = 0] = "NORMAL";
    VaultClass[VaultClass["TRUSTED"] = 1] = "TRUSTED";
})(VaultClass || (exports.VaultClass = VaultClass = {}));
function isNormalVaultClass(vaultClass) {
    return (vaultClass & VaultClass.NORMAL) === VaultClass.NORMAL;
}
function isTrustedVaultClass(vaultClass) {
    return (vaultClass & VaultClass.TRUSTED) === VaultClass.TRUSTED;
}
var FuelDistributionMode;
(function (FuelDistributionMode) {
    FuelDistributionMode[FuelDistributionMode["UsersOnly"] = 0] = "UsersOnly";
    FuelDistributionMode[FuelDistributionMode["UsersAndManager"] = 1] = "UsersAndManager";
})(FuelDistributionMode || (exports.FuelDistributionMode = FuelDistributionMode = {}));
var FeeUpdateStatus;
(function (FeeUpdateStatus) {
    FeeUpdateStatus[FeeUpdateStatus["None"] = 0] = "None";
    FeeUpdateStatus[FeeUpdateStatus["PendingFeeUpdate"] = 1] = "PendingFeeUpdate";
})(FeeUpdateStatus || (exports.FeeUpdateStatus = FeeUpdateStatus = {}));
function hasPendingFeeUpdate(status) {
    return ((status & FeeUpdateStatus.PendingFeeUpdate) ===
        FeeUpdateStatus.PendingFeeUpdate);
}
// Logs/Records
class VaultDepositorAction {
}
exports.VaultDepositorAction = VaultDepositorAction;
VaultDepositorAction.DEPOSIT = { deposit: {} };
VaultDepositorAction.WITHDRAW = { withdraw: {} };
VaultDepositorAction.WITHDRAW_REQUEST = { withdrawRequest: {} };
VaultDepositorAction.CANCEL_WITHDRAW_REQUEST = { cancelWithdrawRequest: {} };
VaultDepositorAction.FEE_PAYMENT = { feePayment: {} };
class FeeUpdateAction {
}
exports.FeeUpdateAction = FeeUpdateAction;
FeeUpdateAction.PENDING = { pending: {} };
FeeUpdateAction.APPLIED = { applied: {} };
